import { render } from "./DemoDataVersion101.vue?vue&type=template&id=6fc0cead&scoped=true"
import script from "./DemoDataVersion101.vue?vue&type=script&lang=js"
export * from "./DemoDataVersion101.vue?vue&type=script&lang=js"

import "./DemoDataVersion101.vue?vue&type=style&index=0&id=6fc0cead&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc0cead"]])

export default __exports__